const formatFileSize = (sizeInBytes) => {
  return sizeInBytes / (1024 * 1024);
};
export { formatFileSize };
